import React from 'react';
import { motion } from 'framer-motion';
export function DifferenceSection() {
  return <section className="w-full px-6 py-20 md:py-28 bg-cream-50" data-id="element-27">
      <div className="max-w-2xl mx-auto text-center" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-29">
          <h2 className="font-serif text-3xl md:text-4xl text-stone-800 mb-10" data-id="element-30">
            Why this is different from what you tried
          </h2>

          <blockquote className="font-serif text-2xl md:text-3xl text-terracotta italic mb-10 leading-relaxed" data-id="element-31">
            "It does not ask you to be perfect. It asks you to be consistent."
          </blockquote>

          <p className="text-lg md:text-xl text-stone-600 leading-relaxed" data-id="element-32">
            You do not have to earn results by suffering. You get results by
            removing chaos and installing defaults. That is what adults do when
            they want something to actually stick.
          </p>
        </motion.div>
      </div>
    </section>;
}